import { createLotterySDK, RewardInfo } from "@hg/activity-utils"
import { useMemo } from "react"
import { i18n, RecallTextPath } from "@/i18n"
import { collect, sdkReady } from "@/utils/sdk"
import { useRoleMeta } from "@/user/session"
import Toast from "../Toast"
import { errMsgMap, RewardMap } from "./const"
import Failed from "./UI/Failed"
import PreLottery from "./UI/PreLottery"
import VirtualReward from "./UI/VirtualReward"
import RealReward from "./UI/RealReward"

export const code2Msg = (code: number) => {
    if (code in errMsgMap) {
        return i18n.getRecall(
            errMsgMap[code as keyof typeof errMsgMap] as RecallTextPath
        )
    } else {
        return `未知のエラーが発生しました，code=${code}`
    }
}

export const useRewardLottery = () => {
    const roleMeta = useRoleMeta()

    const lotterySDK = useMemo(() => {
        if (!roleMeta) {
            return null
        }
        return createLotterySDK({
            baseURL: __ACT_SERVER_HOST,
            sdkReady,
            couponCid: __MAIN_SHARE_COUPON_CID,
            activityCid: __ACTIVITY_CID,
            taskCid: __MAIN_SHARE_TASK_CID,
            rewardMap: RewardMap,
            ui: {
                preLotteryContent: PreLottery,
                failedContent: Failed,
                virtualRewardContent: VirtualReward,
                realRewardContent: RealReward,
            },
            callbacks: {
                onCommonError: (error) => {
                    Toast.message(
                        error.code
                            ? code2Msg(error.code)
                            : error.msg || "draw failed"
                    )
                },
                onDrawSuccess(reward: RewardInfo) {
                    collect("lottery", {
                        target: "game",
                        result:
                            reward.type === "virtual"
                                ? "virtual_items"
                                : "material_items",
                    })
                },
            },
            options: {
                enableAnalytics: false,
                enablePreLottery: true,
            },
        })
    }, [roleMeta])

    return lotterySDK
}
